import { Container } from "reactstrap"
import BasicInformation from "./BasicInformation/BasicInformation"
import Targeting from "./Targeting/Targeting"
import ProductSelection from "./ProductSelection/ProductSelection"
import DefaultBid from "./DefaultBid/DefaultBid"
import BiddingStrategy from "./BiddingStrategy/BiddingStrategy"
import { useState } from "react"
import ManualBid from "./ManualBid/ManualBid"
import AddCreative from "./AddCreative/AddCreative"
import PrimaryButton from "../../../../components/common/PrimaryButton/PrimaryButton"

const SponsoredVideoAd = () => {
  const [checkboxState, setCheckboxState] = useState({
    automatic: true,
    manual: false,
  })

  const handleCheckboxChange = (e) => {
    const { name } = e.target
    setCheckboxState({
      automatic: name === "automatic",
      manual: name === "manual",
    })
  }

  return (
    <div style={{ background: "#f2f2f2", minHeight: "100dvh", paddingBlock: "1rem" }}>
      <Container fluid>
        <h4 className="fw-semibold mb-3">Advertisement Campaign Creation</h4>

        <div className="px-2">
          <div className="fw-semibold fs-4 mb-3">Sponsored Video Ad</div>

          <BasicInformation />

          <AddCreative />

          <Targeting checkboxState={checkboxState} handleCheckboxChange={handleCheckboxChange} />

          <ProductSelection />

          {checkboxState.automatic && (
            <>
              <DefaultBid />
              <BiddingStrategy />
            </>
          )}
          {checkboxState.manual && <ManualBid />}
        </div>
        
        <div className="d-flex justify-content-center mt-3">
          <span>
            <PrimaryButton name="Launch Campaign" />
          </span>
        </div>
      </Container>
    </div>
  )
}

export default SponsoredVideoAd
